import React, { useContext, useMemo } from "react";
import { BsFacebook, BsTwitter, BsLinkedin, BsInstagram } from "react-icons/bs";
import { MdLocationPin, MdLocalPhone } from "react-icons/md";
import { FaBars, FaInstagram } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { Link, useLocation } from "react-router-dom";
import "./../Header/Header.css";
import CommonContext from "../../Context/context";
import { logo } from "../../Images";

const Header = () => {
  const { GlobalData, ContactNumber, LocationLink, AllLink } =
    useContext(CommonContext);
  const location = useLocation();
  const loco = location.pathname;
  // const [faceBookLink, InstagramLink, TwitterLink, LinkedInLink] = AllLink;
  const faceBookLink = AllLink.find((e) => e?.includes("www.facebook.com"));
  const InstagramLink = AllLink.find((e) => e?.includes("www.instagram.com"));
  const TwitterLink = AllLink.find((e) => e?.includes("https://twitter.com/"));
  const address = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "address")?.file,
    [GlobalData]
  );
  return (
    <>
      <div className="site-mobile-menu site-navbar-target">
        <div className="site-mobile-menu-header">
          <div className="site-mobile-menu-close mt-3">
            <span className="icon-close2 js-menu-toggle">
              <RxCross1 />
            </span>
          </div>
        </div>
        <div className="site-mobile-menu-body"></div>
      </div>
      <div className="site-navbar-wrap">
        <div className="site-navbar-top">
          <div className="container-fluid py-2">
            <div className="menu-area">
              <div className="row align-items-center">
                <div className="col-9 top-left-bar">
                  <div className="d-flex mr-auto">
                    <Link
                      to="/"
                      className="d-flex align-items-center mr-4 first-ele"
                    >
                      <MdLocationPin />
                      <span className="d-none d-md-inline-block">
                        {address?.slice(38, 92) || "Address Kolkata"}
                      </span>
                    </Link>
                    <Link to="/" className="d-flex align-items-center mr-auto">
                      <MdLocalPhone />
                      <span className="d-none d-md-inline-block">
                        +91&nbsp;
                        {ContactNumber?.file || "0000000000"}
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="col-3 text-right">
                  <div className="mr-auto">
                    {faceBookLink && (
                      <Link
                        to={faceBookLink ? faceBookLink : ""}
                        className="p-2 pl-0"
                      >
                        <BsFacebook />
                      </Link>
                    )}
                    {TwitterLink && (
                      <Link
                        to={TwitterLink ? TwitterLink : ""}
                        className="p-2 pl-0"
                      >
                        <BsTwitter />
                      </Link>
                    )}
                    {InstagramLink && (
                      <Link
                        to={InstagramLink ? InstagramLink : ""}
                        className="p-2 pl-0"
                      >
                        <FaInstagram />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-navbar site-navbar-target js-sticky-header">
          <div className="container-fluid">
            <div className="menu-area">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-4 col-sm-9 col-xs-8 main-logo">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={logo}
                      style={{ height: "70px", width: "70px" }}
                      alt="logo"
                    />
                    <h1 className="site-logo">
                      <Link to="/">
                        Bharatpur St. Mary <br />
                        (Eng.) School
                      </Link>
                    </h1>
                  </div>
                </div>
                <div className="col-lg-9 col-md-8 col-sm-3 col-xs-4">
                  <nav className="site-navigation text-right" role="navigation">
                    <div className="container">
                      <div className="d-inline-block d-lg-none ml-md-0 mr-auto py-3">
                        <Link
                          to="/"
                          className="site-menu-toggle js-menu-toggle text-white"
                        >
                          <span className="icon-menu h3">
                            <FaBars />
                          </span>
                        </Link>
                      </div>
                      <ul className="site-menu main-menu js-clone-nav d-none d-lg-block">
                        <li className={loco === "/" ? "active" : ""}>
                          <Link to="/" className="nav-link">
                            Home
                          </Link>
                        </li>
                        <li className={loco === "/about" ? "active" : ""}>
                          <Link to="/about" className="nav-link">
                            About Us
                          </Link>
                        </li>
                        <li className={loco === "/gallery" ? "active" : ""}>
                          <Link to="/gallery" className="nav-link">
                            Gallery
                          </Link>
                        </li>
                        <li className={loco === "/notice" ? "active" : ""}>
                          <Link to="/notice" className="nav-link">
                            Notice Board
                          </Link>
                        </li>
                        <li className={loco === "/recruitment" ? "active" : ""}>
                          <Link to="/recruitment" className="nav-link">
                            Recruitment
                          </Link>
                        </li>
                        <li className={loco === "/admission" ? "active" : ""}>
                          <Link to="/admission" className="nav-link">
                            Admission
                          </Link>
                        </li>
                        <li className={loco === "/contact" ? "active" : ""}>
                          <Link to="/contact" className="nav-link">
                            Contact Us
                          </Link>
                        </li>
                        {/* <li className={loco === "/payment" ? "active" : ""}>
                          <Link to="/payment" className="nav-link">
                            Payment
                          </Link>
                        </li> */}
                        {/* <li
                          className={loco === "/privacypolicy" ? "active" : ""}
                        >
                          <Link to="/privacypolicy" className="nav-link">
                            Privacy Policy
                          </Link>
                        </li> */}

                        {/* <li
                          className={
                            loco === "/cancellation/refundpolicy"
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to="/cancellation/refundpolicy"
                            className="nav-link"
                          >
                            Cancellation/Refund Policy
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
